var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Jodit } from "jodit-react";
export var buttons = [
    "bold",
    "italic",
    "underline",
    "|",
    "font",
    "fontsize",
    "paragraph",
    "link",
    "unlink",
    "subscript",
    "superscript",
    "ul",
    "ol",
    "|",
    "table",
    "image",
    "|",
    "source",
];
export var fontsWithSizes = function (fonts, sizes) {
    if (fonts === void 0) { fonts = {}; }
    if (sizes === void 0) { sizes = {}; }
    return ({
        font: {
            list: Jodit.atom(__assign({ "Roboto,Verdana": "Roboto (default)", "'Open Sans',Roboto,Verdana": "Open Sans", Verdana: "Verdana", "SFMono-Regular, monospace": "Monospace", "'Times New Roman',Times,serif": "Times New Roman" }, fonts)),
        },
        fontsize: {
            list: __assign({ "11": "11", "12": "12", "13": "13", "14": "14", "15": "15", "16": "16", "17": "17", "18": "18", "20": "20", "24": "24", "34": "34" }, sizes),
        },
    });
};
export var plaintextConfig = {
    buttons: [],
    askBeforePasteHTML: false,
    defaultActionOnPaste: "insert_only_text",
    showXPathInStatusbar: false,
    askBeforePasteFromWord: false,
    disablePlugins: "font,bold,add-new-line,about,hotkeys,line-height,paste-from-word,ordered-list,limit,drag-and-drop,drag-and-drop-element,wrap-nodes,class-span,color,media,image,video,file,format-block,link, powered-by-jodit",
};
export var strip = function (value) { return value.replace(/<[^>]+>/g, ""); };
export var useStringifiedDependency = function (dependency) {
    /**
     * Usage of object-like dependencies can cause a lot of issues,
     * if it's not possible to add just number, boolean or plain string
     * stringified object should do the trick
     * https://stackoverflow.com/questions/59467758/passing-array-to-useeffect-dependency-list
     */
    try {
        return JSON.stringify(dependency);
    }
    catch (e) {
        return dependency;
    }
};
